import React, { useState } from "react";
import API from "services/axios";
import Footer from "components/Footer";
import NavLight from "components/Nav/NavLight";

function ContactUs() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);
    setError(null);
    try {
      await API.post("/erp/contact", form);
      setSuccess("Thank you for contacting us! We'll get back to you soon.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <NavLight />
      <section
        className="contact-hero d-flex align-items-center justify-content-center text-center bg-primary text-white"
        style={{
          minHeight: 260,
          background: "linear-gradient(90deg,#0d6efd 0%, #6f42c1 100%)",
        }}
      >
        <div className="container">
          <h1 className="display-5 fw-bold mb-2">Contact Us</h1>
          <p className="lead mb-0">
            We'd love to hear from you. Please fill out the form below and our
            team will get in touch soon.
          </p>
        </div>
      </section>

      <section className="py-4 bg-light">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="fw-bold mb-3">
                If you have any questions, suggestions or feedback — contact us
              </h2>
              <p className="text-muted h5 mb-0">
                We're happy to help. Reach out and we'll get back to you within
                one business day.
              </p>
            </div>
          </div>
          <div className="row g-4 align-items-start mx-auto">
            {/* Left column: vertical contact info (desktop) / top on mobile */}
            <div className="col-12 col-lg-5 order-1">
              <div className="d-flex flex-column gap-3">
                <div className="p-3 rounded-3 bg-white shadow-sm d-flex gap-3 align-items-start">
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: 44, height: 44 }}
                  >
                    <i className="mdi h4 mdi-email-outline"></i>
                  </div>
                  <div>
                    <h6 className="mb-1 mt-1 h4 fw-bold">Email</h6>
                    <a
                      href="mailto:info@sportswearserp.com"
                      className="text-muted"
                    >
                      info@sportswearserp.com
                    </a>
                  </div>
                </div>

                <div className="p-3 rounded-3 bg-white shadow-sm d-flex gap-3 align-items-start">
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: 44, height: 44 }}
                  >
                    <i className="mdi h4 mdi-phone-outline"></i>
                  </div>
                  <div>
                    <h6 className="mb-1 mt-1 h4 fw-bold">Phone</h6>
                    <a href="tel:+1234567890" className="text-muted">
                      +1 (234) 567-890
                    </a>
                  </div>
                </div>

                <div className="p-3 rounded-3 bg-white shadow-sm d-flex gap-3 align-items-start">
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: 44, height: 44 }}
                  >
                    <i className="mdi h4 mdi-map-marker-outline"></i>
                  </div>
                  <div>
                    <h6 className="mb-1 mt-1 h4 fw-bold">Address</h6>
                    <p className="text-muted mb-0">
                      Atlanta, USA
                      {/* 123 Sportswear Ave, Suite 400
                      <br />
                      Cityville, ST 12345 */}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right column: form (desktop) / appears below on mobile */}
            <div className="col-12 col-lg-7 order-2">
              <div className="card shadow border-0 rounded-4 p-4">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="h4s fw-semibold">Name</label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      required
                      disabled={loading}
                      placeholder="Your Name"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="h4s fw-semibold">Email</label>
                    <input
                      type="email"
                      className="form-control form-control-lg"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      disabled={loading}
                      placeholder="you@email.com"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="h4s fw-semibold">Message</label>
                    <textarea
                      className="form-control form-control-lg"
                      name="message"
                      rows={6}
                      value={form.message}
                      onChange={handleChange}
                      required
                      disabled={loading}
                      placeholder="How can we help you?"
                    />
                  </div>
                  {success && (
                    <div className="alert alert-success">{success}</div>
                  )}
                  {error && <div className="alert alert-danger">{error}</div>}
                  <div className="d-grid mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg rounded-pill shadow-sm"
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Send Message"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <style>{`
        .contact-hero {
          background: linear-gradient(90deg,#0d6efd 0%, #6f42c1 100%);
        }
        .card {
          border-radius: 1.5rem;
        }
        .btn-primary {
          background: linear-gradient(90deg,#0d6efd 0%, #6f42c1 100%);
          border: none;
        }
        .btn-primary:focus, .btn-primary:hover {
          background: #0b5ed7;
        }
      `}</style>
    </>
  );
}

export default ContactUs;
